import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchRegions } from 'shared/stores/store';
import {useTranslation} from "react-i18next";
import RegionGrid from "./Widgets/RegionGrid";

export default function RegionsPage() {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();
    const regions = useSelector((state) => state.regions.list);
    const loading = useSelector((state) => state.regions.loading);
    const error = useSelector((state) => state.regions.error);

    useEffect(() => {
        dispatch(fetchRegions());
    }, [dispatch]);

    if (loading) return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="text-center">{t('regions.page.loading')}</div>
        </div>
    );

    if (error) return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="text-center text-red-500">{t('regions.page.error', { error })}</div>
        </div>
    );

    return (
        <div className="bg-white pt-24">

            <RegionGrid
                regions={regions}
                title={t('regions.page.title')}
                description={t('regions.page.description')}
            />

            <div className="mx-auto max-w-2xl sm:px-6 sm:py-12 lg:max-w-7xl lg:px-8">

                {/* Additional Information */}
                <div className=" rounded-2xl bg-gray-50 px-6 py-12 sm:px-12">
                    <div className="max-w-3xl">
                        <h2 className="text-2xl font-bold tracking-tight text-gray-900">
                            {t('regions.page.cta.title')}
                        </h2>
                        <p className="mt-4 text-gray-500">
                            {t('regions.page.cta.description')}
                        </p>
                        <div className="mt-6">
                            <Link
                                to="/contact"
                                className="text-sm font-semibold leading-6 text-sky-600"
                            >
                                {t('regions.page.cta.contact')} <span aria-hidden="true">→</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="relative">
                <img
                    src="https://images.pexels.com/photos/1791684/pexels-photo-1791684.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                    alt="Beautiful landscape in Spain"
                    className="absolute inset-0 h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gray-900/70"></div>
                <div className="relative px-6 py-24 sm:px-6 sm:py-32 lg:px-8">
                    <div className="mx-auto max-w-2xl text-center">
                        <h2 className="text-balance text-4xl leading-10 font-semibold tracking-tight text-white sm:text-5xl">
                            Opret en profil og få mere ud af din boligsøgning
                        </h2>
                        <p className="mx-auto mt-6 max-w-xl text-pretty text-lg/8 text-white">
                            Når du er logget ind, kan du gemme dine foretrukne ejendomme, få besked om prisændringer
                            og overvåge markedet med få klik. Gør din ejendomssøgning nemmere og mere effektiv.
                        </p>
                        <div className="mt-10 flex items-center justify-center gap-x-6">
                            <a
                                href="#"
                                className="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-sky-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                            >
                                Opret profil
                            </a>
                            <a href="#" className="text-sm font-semibold leading-6 text-white">
                                Log ind <span aria-hidden="true">→</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}